const BASE_URL = process.env.REACT_APP_BASE_URL;
export const API_BASE_URL = {
  LOGIN: `${BASE_URL}/auth`,
  FORGOT_PASSWORD: `${BASE_URL}/auth/forgot-password`,
  RESET_PASSWORD: `${BASE_URL}/auth/reset-password`,
  SIGNUP: `${BASE_URL}/auth/signup`,
  ESCOLA: `${BASE_URL}/escola`,
  PESSOA: `${BASE_URL}/pessoa`,
  EMISSOR: `${BASE_URL}/emissor`,
  ATA: `${BASE_URL}/ata`,
  USUARIO: `${BASE_URL}/usuario`,
  VINCULO: `${BASE_URL}/vinculo`,
  UF: `${BASE_URL}/uf`,
  MUNICIPIO: `${BASE_URL}/municipio`,
  TEMPLATE: `${BASE_URL}/template`,
  DRIVE_PATH: `${BASE_URL}/drive-path`,
  IMAGEM: `${BASE_URL}/imagem`,
  BANCO: `${BASE_URL}/banco`,
  AGENCIA: `${BASE_URL}/agencia`,
  PROGRAMA: `${BASE_URL}/programa`,
  ACAO: `${BASE_URL}/acao`,
  CONTA: `${BASE_URL}/conta`,
  FAVORECIDO: `${BASE_URL}/favorecido`,
  NATUREZA: `${BASE_URL}/natureza`,
  TIPO_BEM: `${BASE_URL}/tipo-bem`,
  ITEM: `${BASE_URL}/item`,
  RECEITA: `${BASE_URL}/receita`,
  DESPESA: `${BASE_URL}/despesa`,
  BENS: `${BASE_URL}/bens`,
  RENDIMENTO: `${BASE_URL}/rendimento`,
  RECURSO_PROPRIO: `${BASE_URL}/recurso-proprio`,
  SREA: `${BASE_URL}/srea`,
  SREA_AJUSTE: `${BASE_URL}/srea-ajuste`,
  SRES: `${BASE_URL}/sres`,
  DEVOLUCAO: `${BASE_URL}/devolucao`,
  COMPENSACAO: `${BASE_URL}/compensacao`,
  REDISTRIBUICAO: `${BASE_URL}/redistribuicao`,
  CNPJ_PROXY: `${BASE_URL}/cnpj`,
  FNDE: `${BASE_URL}/fnde`,
  DEMONSTRATIVO: `${BASE_URL}/demonstrativos`,
  RELATORIO: `${BASE_URL}/relatorios`,
  ATA_FINAL: `${BASE_URL}/atas-final`,
  SALDO_INVESTIMENTO: `${BASE_URL}/saldos-investimento`,
  SALDO_CONTA: `${BASE_URL}/saldo-conta`,
  SALDO_FNDE: `${BASE_URL}/saldo-fnde`,
  EXTRATO: `${BASE_URL}/extratos`,
  TIPO_PAGAMENTO: `${BASE_URL}/tipo-pagamento`,
  LISTA_COMPRA: `${BASE_URL}/lista-compra`,
  DIRETOR: `${BASE_URL}/diretor`,
  
};
